
export const appMain = [
  {
    name: 'app',
    path: '/app',
    meta: {
      title: 'H5页面装修',
      icon: 'shezhi',
      plugin: 'app'
    }
  },
  {
    name: 'appThemes',
    path: '/app/themes',
    component: () => import('/@/views/plugins/app/Themes.vue'),
    meta: { title: 'H5主题选择', plugin: 'app' }
  },
  {
    name: 'appList',
    path: '/app/list',
    component: () => import('/@/views/plugins/app/List.vue'),
    meta: { title: 'H5装修列表', plugin: 'app' }
  },
  {
    name: 'appMenu',
    path: '/app/menu',
    component: () => import('/@/views/plugins/app/Menu.vue'),
    meta: { title: 'H5菜单列表', plugin: 'app' }
  }
]
export const appOpen = [
  {
    name: 'appHandle',
    path: '/app/handle',
    component: () => import('/@/views/plugins/app/Handle.vue'),
    meta: { title: 'H5页面装修', plugin: 'app' }
  }
]
